import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { eventsService } from "../services/eventsService";

export const useCalendarEvents = (year, month) => {
  const { i18n } = useTranslation();
  const lang = i18n.language?.split("-")[0] ?? "tr";
  return useQuery({
    queryKey: ["events", "calendar", year, month, lang],
    queryFn: () => eventsService.getCompanyCalendarEvents(year, month),
    staleTime: 1000 * 60 * 5,
    enabled: !!year && !!month,
    select: (res) => res?.data ?? res,
  });
};
